module.exports = __webpack_public_path__ + "img/jamaica-logo-icon.9c8f2edc.png";